import { object, string } from 'yup'

let phoneRegExp = /^(0)9\d{9}$/
export const mobileSchema = object({
  mobile: string()
    .required('فیلد شماره موبایل الزامی است.')
    .matches(phoneRegExp, 'شماره موبایل وارد شده صحیح نمی باشد'),
  password: string()
    .required('فیلد رمز عبور الزامی است.')
    .min(8, 'حداقل تعداد کاراکتر باید 8 رقم باشد'),
})

export const userMobileSchema = object({
  mobile: string()
    .required('فیلد شماره موبایل الزامی است.')
    .matches(phoneRegExp, 'شماره موبایل وارد شده صحیح نمی باشد'),
})

export const codeSchema = object({
  verify_code: string().required('وارد کردن کد الزامی است.').min(6, 'کد را به صورت صحیح وارد کنید'),
})
